module.exports = __webpack_public_path__ + "static/media/3024051.0dceb307.jpg";